(() => {
  const WRAPPER_ID = "free-shipping-wrapper";

  const scheduleUpdate = (() => {
    let t1 = null;
    let t2 = null;
    return () => {
      if (t1) clearTimeout(t1);
      if (t2) clearTimeout(t2);
      // 差し替え完了直後を狙う
      t1 = setTimeout(updateFreeShippingBar, 120);
      // 念のため、もう一段後も叩く（テーマ側の再描画に勝つ）
      t2 = setTimeout(updateFreeShippingBar, 600);
    };
  })();

  async function getCartTotalYen() {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
      headers: { "Accept": "application/json" }
    });
    if (!res.ok) throw new Error("Failed to fetch /cart.js");
    const cart = await res.json();
    return (cart.total_price || 0) / 100;
  }

  function renderMessage(wrapper, goalAmount, total) {
    if (!wrapper || !wrapper.isConnected) return;

    if (total >= goalAmount) {
      wrapper.innerHTML = `<div class="free-shipping-message" style="text-align:right;padding-top:12px;color:#cc0000;font-weight:bold;">🎉 送料無料です！</div>`;
      return;
    }

    const remain = goalAmount - total;
    wrapper.innerHTML = `
      <div class="free-shipping-message" style="text-align:right;padding-top:12px;color:#cc0000;">
        🚚 あと <strong>${remain.toLocaleString()}円</strong> で送料無料です！<br>
        <a href="/collections/all" class="free-shipping-link" style="color:#000">&gt;商品の追加はこちら</a>
      </div>
    `;
  }

  async function updateFreeShippingBar() {
    // /cartページ以外では何もしない（誤作動防止）
    if (location.pathname !== "/cart") return;

    const wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper) return;

    const goalAmount = Number(wrapper.dataset.goalAmount || 5000);

    try {
      const total = await getCartTotalYen();
      renderMessage(wrapper, goalAmount, total);
    } catch (e) {
      // ブランクにしない
      wrapper.innerHTML = `<div class="free-shipping-message">送料無料条件を確認中です…</div>`;
    }
  }

  function hookFetch() {
    const origFetch = window.fetch;
    window.fetch = async function (...args) {
      const res = await origFetch.apply(this, args);

      try {
        const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
        // カート変更系 or sections再取得（Dawn/Riseがよく使う）
        if (
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/add") ||
          url.includes("sections=") ||
          url.includes("/?sections=")
        ) {
          scheduleUpdate();
        }
      } catch (_) {}

      return res;
    };
  }

  function hookXHR() {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__fsb_url = url;
      return origOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener("loadend", () => {
        try {
          const url = this.__fsb_url || "";
          if (
            url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/add") ||
            url.includes("sections=") ||
            url.includes("/?sections=")
          ) {
            scheduleUpdate();
          }
        } catch (_) {}
      });

      return origSend.apply(this, args);
    };
  }

  function observeDOM() {
    // wrapper自体が差し替えられたら更新
    const obs = new MutationObserver(() => {
      if (location.pathname !== "/cart") return;
      if (document.getElementById(WRAPPER_ID)) scheduleUpdate();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    hookFetch();
    hookXHR();
    observeDOM();
    // 初回
    scheduleUpdate();
  });
})();
